import React, { useEffect, useState } from "react";
// import CEO from "../../assets/images/team2.jpg";
// import HrTeam from "../../assets/images/hr-team.jpg";
// import Developer from "../../assets/images/java-team.jpg";
// import Support from "../../assets/images/support-team.jpg";
// import Finance from "../../assets/images/account-team.jpg";
// import Sales from "../../assets/images/sales-team.jpg";
import Team from "../../assets/about/our-team.jpg";
import "animate.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import BASE_URL from "../../config/config";
const OurTeam = () => {
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/team-heading/list`, {})
      .then((res) => {
        // console.log("Response:", res);
        setHeadings(res.data.data || []);
      })
      .catch((err) => {
        console.error("Error fetching team headings:", err);
      });
  }, []);

  // for the empolyee data
  const [employee, setEmployee] = useState([]);
  const IMAGE_BASE_URL = `${BASE_URL}/employees/view/`;

  useEffect(() => {
    axios
      .get(`${BASE_URL}/employees/list`, {})
      .then((res) => {
        // console.log("Response:", res);
        setEmployee(res.data.data || []);
      })
      .catch((err) => {
        console.error("Error fetching team headings:", err);
      });
  }, []);

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>
          Meet Our Team - Deetya Soft | Experts in IT & IVR Solutions
        </title>
        <meta
          name="description"
          content="Discover the skilled team behind Deetya Soft’s success in IT services, IVR solutions, and app development. Passionate minds driving innovation."
        />
        <meta
          name="keywords"
          content="Meet the experts behind Deetya Soft, IT Solution Experts Indiac, Deetya Soft Developers, Deetya Soft Team, Meet Our Team Deetya Soft"
        />
        <link rel="canonical" href="https://deetyasoft.com/our-team" />

        {/* Facebook Meta Tags */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://deetyasoft.com/our-team" />
        <meta
          property="og:title"
          content="Meet Our Team - Deetya Soft | Experts in IT & IVR Solutions"
        />
        <meta
          property="og:description"
          content="Discover the skilled team behind Deetya Soft’s success in IT services, IVR solutions, and app development. Passionate minds driving innovation."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/our-team.151655a5e6bf15ce09b2.jpg"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://deetyasoft.com/our-team" />
        <meta
          name="twitter:title"
          content="Meet Our Team - Deetya Soft | Experts in IT & IVR Solutions"
        />
        <meta
          name="twitter:description"
          content="Discover the skilled team behind Deetya Soft’s success in IT services, IVR solutions, and app development. Passionate minds driving innovation."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/our-team.151655a5e6bf15ce09b2.jpg"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        {/* Extra Meta Tags */}
        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow" />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta httpEquiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "Deetya Soft Pvt Ltd",
          "description": "Discover the skilled team behind Deetya Soft’s success in IT services, IVR solutions, and app development. Passionate minds driving innovation.",
          "image": "https://deetyasoft.com/static/media/our-team.151655a5e6bf15ce09b2.jpg",
          "logo": "https://www.deetyasoft.com/images/logo.png",
          "url": "https://www.deetyasoft.com",
          "telephone": ["+91-9015350505", "+91-9717055088"],
          "email": "info@deetyasoft.com",
          "sameAs": [
            "https://www.linkedin.com/company/deetya-soft-private-limited",
            "https://www.facebook.com/deetyasoftprivatelimited",
            "https://www.instagram.com/deetyasoft",
            "https://www.youtube.com/@deetyasoft",
            "https://www.crunchbase.com/organization/deetyasoft"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
            "addressLocality": "Ghaziabad",
            "addressRegion": "Uttar Pradesh",
            "postalCode": "201014",
            "addressCountry": "IN"
          }
        }`}
        </script>

        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "url": "https://www.deetyasoft.com",
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+91-981-862-7588",
              "contactType": "technical support",
              "areaServed": "IN"
            },
            {
              "@type": "ContactPoint",
              "telephone": "+91-901-535-0505",
              "contactType": "sales",
              "areaServed": "IN"
            }
          ]
        }`}
        </script>

        <script type="application/ld+json">
          {`{
          "@context": "http://schema.org",
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Parshan "
          },
          "reviewBody": "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
          "url": "https://www.deetyasoft.com/",
          "description": "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
          "datePublished": "2025-06-17",
          "name": "Deetya Soft Pvt Ltd",
          "reviewRating": {
            "@type": "Rating",
            "worstRating": "1",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "itemReviewed": {
            "@type": "Organization",
            "name": "Deetya Soft Pvt Ltd"
          }
        }`}
        </script>
      </Helmet>

      <div
        className="relative text-center py-16  bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${Team})` }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="flex mx-auto items-center justify-center">
          <div className="relative max-w-3xl px-6 py-2">
            <div className="absolute rounded-xl inset-0 bg-[rgba(0,0,0,0.2)]"></div>
            <div className="relative z-10 text-white drop-shadow-xl flex flex-col items-center justify-center h-full">
              <h1 className="md:text-4xl text-2xl font-bold mb-4">Our Team</h1>
              <p className="md:text-lg text-sm">
                Behind every great product is a great team.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-end px-3 my-4">
        <nav className="text-sm text-gray-600 flex items-center space-x-2">
          <Link to="/" className="hover:text-main1 font-semibold">
            Home
          </Link>
          <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
          <Link to="/team" className="hover:text-main1 ">
            Team
          </Link>
        </nav>
      </div>

      {/* trail section here */}

      <div className="w-full">
        {/* Breadcrumbs below image, aligned right */}
      </div>

      <div className="w-full bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-10">
            <div>
              {/* <h1 className="text-2xl md:text-3xl font-semibold text-center text-heading pb-4 md:pb-6">
                Our Biggest Asset is Our Team
              </h1>
              <p className="text-base md:text-lg text-center text-gray-700 leading-relaxed max-w-3xl mx-auto pb-6 md:pb-10">
                Our team thrives on collaboration and is fueled by a diverse
                array of talent. We actively engage with the creative community,
                consistently seeking out what’s on the horizon, and always
                maintain a positive and welcoming atmosphere.
              </p> */}
              <div>
                {headings?.length > 0 && (
                  <>
                    <h1 className="text-2xl md:text-3xl font-semibold text-center text-heading pb-4 md:pb-6">
                      {headings[0].title}
                    </h1>
                    <p className="text-base md:text-lg text-center text-gray-700 leading-relaxed max-w-3xl mx-auto pb-6 md:pb-10">
                      {headings[0].description}
                    </p>
                  </>
                )}
              </div>
            </div>
            {/* employee data */}
            {employee?.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-4  gap-2 md:gap-6">
                {employee?.map((member) => (
                  <div
                    key={member._id}
                    className="w-full h-auto cursor-pointer  border md:border-0 overflow-hidden "
                  >
                    <div className="relative w-40 h-40 mt-5  sm:w-44 sm:h-44 md:w-48 md:h-48 mx-auto flex items-center justify-center">
                      {/* Blob background as overlay */}
                      <div className="absolute inset-0 bg-[#e6f9fa] rounded-[30%_70%_70%_30%_/_30%_30%_70%_70%] scale-[1.2] z-0"></div>

                      {/* Profile image */}
                      <img
                        // src={member.path || "/image/default.png"}
                        src={
                          member?.fileName
                            ? `${IMAGE_BASE_URL}${member.fileName}`
                            : "/image/default.png"
                        }
                        alt={member.name || "Team Member"}
                        className="relative z-10 w-full h-full object-cover rounded-full"
                        style={{
                          borderRadius: "40% 70% 70% 30% / 30% 30% 70% 70%",
                        }}
                      />
                    </div>

                    <div className=" py-4 mt-2">
                      <h3 className="md:font-bold font-semibold text-center md:text-xl text-lg text-gray-900">
                        {member.name}
                      </h3>
                      <p className="text-gray-700 text-center text-base ">
                        {member.designation}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-10 text-lg font-semibold text-gray-700">
                No members listed.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OurTeam;
